export default __webpack_public_path__ + "static/media/hoisting-capacity-of-bucket-elevators.42df4def.jpg";